import s from './SiteFooter.module.css'

export default function SiteFooter() {
  return (
    <footer className={s.foot}>
      <div className={s.wrap}>© {new Date().getFullYear()} pyhc. All rights reserved.</div>
    </footer>
  )
}
